// Import just what we need

import 'bootstrap/js/src/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import Collapse from 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

import setupToolbar from './toolbar.js';
import setupSidebar from './sidebar.js';
import { setupTalkButtons, setupRandomTalk } from './audio.js';
// Import the old style accordion behavior.
import { setupAccordion, setupOldAccordion } from './accordion.js';
import { onready, onload } from './utils.js';

window.setupRandomTalk = setupRandomTalk;

onload(function() {
    window.toolbarDestructor = setupToolbar();
});

onready(function() {
    setupSidebar();
    setupAccordion();
    setupOldAccordion();
    setupTalkButtons();

    var navCollapse = document.querySelector("#navSearch.collapse");
    navCollapse?.addEventListener("shown.bs.collapse", function() {
        this.children[0].focus();
    });

    // Swap out show/hide text for collapse toggles that have a
    // "data-hide-text" attribute set.
    document.querySelectorAll("[data-hide-text], [data-show-text]").forEach(el => {
        const button = el.closest("[data-bs-toggle='collapse']");
        if (button == null)
            return;
        const targetSel = button.getAttribute("data-bs-target") ?? button.getAttribute("href");
        const collapseEl = document.querySelector(targetSel);
        collapseEl.addEventListener("hide.bs.collapse", (e) => {
            if (e.target != collapseEl)
                return
            el.setAttribute("data-hide-text", el.innerText);
            el.innerText = el.getAttribute("data-show-text");
        });
        collapseEl.addEventListener("show.bs.collapse", (e) => {
            if (e.target != collapseEl)
                return
            el.setAttribute("data-show-text", el.innerText);
            el.innerText = el.getAttribute("data-hide-text");
        });
    });
});
